// getDynamicPageLimit.js
'use strict';
import clamp from 'lodash/clamp';

import {
  MAX_CHATROOM_MESSAGES_PAGE_SIZE_LIMIT,
  MIN_CHATROOM_MESSAGES_PAGE_SIZE_LIMIT,
} from '../resource/chatroomConstants.js';

/**
 * Get dynamic page limit
 * @param {number} totalCount - number of total messages.
 * @return {number} - dynamic page limit.
 */
function getDynamicPageLimit(totalCount = 0) {
  const computedPageLimit =
    Math.floor(totalCount / MAX_CHATROOM_MESSAGES_PAGE_SIZE_LIMIT) ||
    MIN_CHATROOM_MESSAGES_PAGE_SIZE_LIMIT;
  const dynamicPageLimit = clamp(
    computedPageLimit,
    MIN_CHATROOM_MESSAGES_PAGE_SIZE_LIMIT,
    MAX_CHATROOM_MESSAGES_PAGE_SIZE_LIMIT
  );

  return dynamicPageLimit;
}

export default getDynamicPageLimit;
